// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"F4-z","colorTextValue":"G4-z","swatches":"H4-z","collapseLink":"I4-z","isCollapsed":"J4-z","dropdown":"K4-z","disabled":"L4-z"};